<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <a-spin :spinning="spinning">
        <!-- <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'> -->
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="As of"><br>
                                        <a-date-picker v-model="inputDate" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%" disabled/>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Company">
                                        <a-select v-model="inputCompany" showSearch allowClear placeholder="Select Company" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getCompanySites()">
                                            <a-select-option v-for="option in userCompanyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch allowClear placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in userSiteCompanyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Format" >
                                        <select class="form-control" size="large" v-model="inputFormat" @click.prevent="autoDisable">
                                            <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select v-if="inputFormat == '1'" class="form-control" size="large" v-model="inputSortBy" @click.prevent="autoChange">
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                        <select v-else class="form-control" size="large" v-model="inputSortExtendedBy" @click.prevent="autoChange">
                                            <option v-for="option in sortExtendedOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Display onhand">
                                        <select class="form-control" size="large" v-model="inputDisplay">
                                            <option v-for="option in displayOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <base-checkbox class="mb-3" v-model="isShowPrev">
                                Show items with previous transactions
                            </base-checkbox>
                            <base-checkbox class="mb-3" v-model="isConsider" :disabled="inputFormat == '1'">
                                Consider Transfer In in Last Arrival
                            </base-checkbox>
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate per site
                            </base-checkbox>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+fileDate">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+fileDate" type="xlsx" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
        </a-spin>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils, {dissectReportFilters} from '../../components/reportUtils';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'

    import {
        mapState,
        mapActions
    } from 'vuex'
import { getReportDescription } from '../../utilities';
    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: moment().endOf('day'),
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'}
                ],
                inputSite: [],
                inputCompany: '',
                site_type: "ho",
                siteOptions: [],
                userSiteCompanyOptions: [],
                companyOptions: [],
                userCompanyOptions: [],
                inputSortBy: 'product_id',
                inputSortExtendedBy: 'product_id',
                sortOptions: [
                    {key: 'product_id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'On-Hand Quantity'}
                ],
                sortExtendedOptions: [
                    {key: 'product_id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'On-Hand Quantity'},
                    {key: 'rr_date', value: 'Last Arrival'},
                    {key: 'in_qty', value: 'Incoming Quantity'},
                    {key: 'out_qty', value: 'Outgoing Quantity'}
                ],
                inputFormat: '1',
                formatOptions: [
                    {key: '1', value: 'Simple'},
                    {key: '2', value: 'Extended'},
                    {key: '3', value: 'Extended with # of days since last sale'},
                    {key: '4', value: 'Inventory List'},
                    {key: '5', value: 'Flat File - Simple'},
                    {key: '6', value: 'Flat File - Extended'}
                ],
                inputDisplay: '1',
                displayOptions: [
                    {key: '1', value: 'All items regardless of onhand quantity'},
                    {key: '2', value: 'All items with onhand quantity only'},
                    {key: '3', value: 'All items with zero onhand quantity only'},
                    {key: '4', value: 'All items with negative onhand quantity only'},
                    {key: '5', value: 'All items with negative or zero onhand quantity'},
                    {key: '6', value: 'All items with positive or zero onhand quantity'},
                    {key: '7', value: 'All items except those with zero quantity'},
                ],
                isShowPrev: false,
                isConsider: false,
                isSeparateSite: true,
                birSalesReports: [],

                //currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                JsonData: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,
                spinning: false,
                accessRights:[],
                accessCostPriceRights: [],
                reportDescription: '',
                fileDate: null,
                // bryan
                selectedLocation: null,
                locationOptions:[],
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            var companies = await HTTPRequest.getRequest(component_x.endPoint + "companies/get_valid_companies", null);
            component_x.companyOptions = companies;
            component_x.sort(component_x.companyOptions);

            //Get user sites company ids then map to component_x.companyOptions
            const company_ids = [...new Set(sites.map(item => item.company_id))];
            companies.forEach(function (item) {
                if(company_ids.includes(item.id)){
                    component_x.userCompanyOptions.push(item)
                }
            });
           
          // bryan
            this.siteOptions.map(({location_name}) => {
              if(this.locationOptions.length === 0 || !this.locationOptions.includes(location_name)){
                this.locationOptions = [...this.locationOptions,location_name].sort()
              }
            })
            // end

            // let siteId = secureStorage.getItem("defaultSiteId")
            // this.inputSite = [siteId]

            // let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            // if(site != undefined){
            //     this.site_type = site.site_type
            // }
            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
            this.reportDescription = await getReportDescription(this.currentProfile)
        },
        computed: {
            ...mapState(['currentProfile','endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            getCompanySites() {
                // clear the selected sites when the company changes
                this.inputSite = []; 

                // load site options under the selected company
                this.userSiteCompanyOptions = [];
                this.siteOptions.forEach(function (item) {
                    if (this.inputCompany == item.company_id) {
                        this.userSiteCompanyOptions.push(item);
                    }
                }, this);
            },

            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(this.inputFormat == '1'){
                    this.inputSortExtendedBy = this.inputSortBy
                } else {
                    if(e.target.value == 'product_id' || e.target.value == 'barcode' || e.target.value == 'name' || e.target.value == 'onhand_qty'){
                        this.inputSortBy = this.inputSortExtendedBy
                    } else {
                        this.inputSortBy = 'product_id'
                    }
                }
            },
            autoDisable(e){
                if(this.inputFormat == '1'){
                    this.isConsider = false
                }

                if(this.inputFormat == '4'){
                    this.inputDate =  moment().endOf('day')
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            convertToCurrency(num){
                return Number(num)
                // return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            qtyFormatter(num){
                return Number(num);
                // return Number(num).toLocaleString();
            },
            formatNumber(num) {
                return Number(num);
            //    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            diffDays(date1, date2){
                let a = moment(date1,'YYYY-MM-DD');
                let b = moment(date2,'YYYY-MM-DD');
                return b.diff(a, 'days');
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let sorting = this.inputSortBy
                if(this.inputFormat != '1'){
                    sorting = this.inputSortExtendedBy
                }

                let as_of = this.inputDate.format('MMMM DD, YYYY')

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "isTI": this.isConsider,
                    "isFormat": this.inputFormat,
                    "isPrev": this.isShowPrev,
                    "advanced_filter": this.params
                }
                let get_request = []
                if(this.inputFormat == 4){
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory_list?', parameters);
                }
                else {
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory?', parameters);
                }

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if (get_request.data !=undefined){
                    siteSpecific = get_request.data;
                }
                if(siteSpecific.length > 0){
                    let doc = []
                    if(this.inputFormat == '1'){
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
                    }

                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];

                    let header_top = [];
                    let header_detail = [];
                    if(this.inputFormat == '1'){
                        header_top.push(
                            // {content: 'PCode', styles: {halign: 'center'}},
                            {content: 'Barcode', styles: {halign: 'center'}},
                            // {content: 'Stock #', styles: {halign: 'center'}},
                            // {content: 'Ref Code', styles: {halign: 'center'}},
                            {content: 'Description', styles: {halign: 'center'}},
                            {content: 'Good', styles: {halign: 'center'}},
                            {content: 'Damaged', styles: {halign: 'center'}},
                            {content: 'Disposal', styles: {halign: 'center'}},
                            {content: 'Losses', styles: {halign: 'center'}},
                            {content: 'Reserved', styles: {halign: 'center'}},
                            // {content: 'Good On-hand Qty', styles: {halign: 'center'}},
                            // {content: 'Damaged On-hand Qty', styles: {halign: 'center'}},
                            // {content: 'Damaged AQT', styles: {halign: 'center'}},
                            // {content: 'Disposal On-hand Qty', styles: {halign: 'center'}},
                            // {content: 'Disposal AQT', styles: {halign: 'center'}},
                            // {content: 'Losses On-hand Qty', styles: {halign: 'center'}},
                            // {content: 'Losses AQT', styles: {halign: 'center'}},
                            // {content: 'Reserved On-hand Qty', styles: {halign: 'center'}},
                            // {content: 'Reserved AQT', styles: {halign: 'center'}},
                            {content: 'On-Hand', styles: {halign: 'center'}},
                            {content: 'In-Transit', styles: {halign: 'center'}},
                            {content: 'Available Quantity to Transact', styles: {halign: 'center'}}
                        )

                        headers = [header_top]
                    } else {
                        header_top.push(
                            // {content: 'PCode', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Barcode', rowSpan: 2, styles: {halign: 'center'}},
                            // {content: 'Stock #', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Description', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'On-Hand', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'In-Transit', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Incoming', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Outgoing', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Available', rowSpan: 2, styles: {halign: 'center'}}
                        )

                        if(this.inputFormat == '3'){
                            header_top.push(
                                {content: '# of day/s\nsince last sale', rowSpan: 2, styles: {halign: 'center'}}
                            )
                        }

                        let arrival_header = 'Last Arrival (RR Document)'
                        if(this.isConsider == true){
                            arrival_header = 'Last Arrival (RR/STI Document)'
                        }
                        header_top.push(
                            {content: arrival_header, colSpan: 3, styles: {halign: 'center'}}
                        )

                        header_detail.push(
                            {content: 'Date', styles: {halign: 'center'}},
                            {content: 'Quantity', styles: {halign: 'center'}},
                            {content: 'Cost', styles: {halign: 'center'}}
                        )

                        headers = [header_top, header_detail]
                    }

                    // console.log("-------------------")
                    // console.log("headers",headers)

                    for(let x=0; x < siteSpecific.length; x++){
                        // console.log("siteSpecific",siteSpecific);
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_onhand_qty = 0
                            let total_intransit_qty = 0

                            let total_in_qty = 0
                            let total_good_qty = 0
                            let total_good_aqt = 0
                            let total_damaged_qty = 0
                            let total_damaged_aqt = 0
                            let total_disposal_qty = 0
                            let total_disposal_aqt = 0
                            let total_losses_qty = 0
                            let total_losses_aqt = 0
                            let total_reserved_qty = 0
                            let total_reserved_aqt = 0
                            let total_out_qty = 0
                            let total_rr_qty = 0
                            let total_rr_cost = 0
                            let total_available = 0


                            let grand_onhand_qty = 0
                            let grand_intransit_qty = 0
                            let grand_in_qty = 0
                            let grand_out_qty = 0
                            let grand_rr_qty = 0
                            let grand_rr_cost = 0
                            let grand_available = 0
                            let grand_good_qty = 0
                            let grand_good_aqt = 0
                            let grand_damaged_qty = 0
                            let grand_damaged_aqt = 0
                            let grand_disposal_qty = 0
                            let grand_disposal_aqt = 0
                            let grand_losses_qty = 0
                            let grand_losses_aqt = 0
                            let grand_reserved_qty = 0
                            let grand_reserved_aqt = 0
                            let totalOnHandQty = 0;

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_name){
                                        let detail_header = [{content: grouper_name, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_name

                                let as_of_date = this.inputDate.format('YYYY-MM-DD')

                                let no_days_display = ''
                                if(reportLine.sales_date != null){
                                    let no_days = this.diffDays(reportLine.sales_date, as_of_date)
                                    no_days_display = this.formatNumber(Number(no_days))
                                }

                                let rr_date = ''
                                let rr_qty = ''
                                let rr_cost = ''
                                if(reportLine.rr_date != null){
                                    rr_date = reportLine.rr_date
                                    rr_qty = this.qtyFormatter(reportLine.rr_qty)
                                    rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                                }
                                let available = Number(reportLine.onhand_qty) - Number(reportLine.out_qty)
                                let detail = [
                                    //reportLine.product_id,
                                    reportLine.barcode,
                                    // reportLine.stock_no
                                ]
                                if(this.inputFormat == '1'){
                                    //detail.push(reportLine.reference_code)
                                }
                                detail.push(
                                    {content: 
                                    reportLine.name, styles: {halign: 'left'}},
                                    this.qtyFormatter(reportLine.good_onhand),
                                    //this.qtyFormatter(reportLine.good_aqt),
                                    this.qtyFormatter(reportLine.damaged_onhand),
                                    //this.qtyFormatter(reportLine.damaged_aqt),
                                    this.qtyFormatter(reportLine.disposal_onhand),
                                    //this.qtyFormatter(reportLine.disposal_aqt),
                                    this.qtyFormatter(reportLine.losses_onhand),
                                    //this.qtyFormatter(reportLine.losses_aqt),
                                    this.qtyFormatter(reportLine.reserved_onhand),
                                    //this.qtyFormatter(reportLine.reserved_aqt),
                                    this.qtyFormatter(reportLine.onhand_qty),
                                    this.qtyFormatter(reportLine.intransit_qty),
                                    this.qtyFormatter(reportLine.good_aqt)
                                )
                                if(this.inputFormat != '1'){
                                    detail.push(
                                        this.qtyFormatter(Number(reportLine.in_qty)),
                                        this.qtyFormatter(Number(reportLine.out_qty)),
                                        this.qtyFormatter(available)
                                    )
                                }
                                if(this.inputFormat == '3'){
                                    detail.push(no_days_display)
                                }
                                if(this.inputFormat != '1'){
                                    detail.push(rr_date, rr_qty, this.addMaskValidation(rr_cost), 'Z')
                                }
                                reportData.push(Object.assign({}, detail))

                                total_onhand_qty += Number(reportLine.onhand_qty)
                                grand_onhand_qty += Number(reportLine.onhand_qty)
                                total_intransit_qty += Number(reportLine.intransit_qty)
                                grand_intransit_qty += Number(reportLine.intransit_qty)

                                total_good_qty += Number(reportLine.good_onhand)
                                total_good_aqt += Number(reportLine.good_aqt)
                                total_damaged_qty += Number(reportLine.damaged_onhand)
                                total_damaged_aqt += Number(reportLine.damaged_aqt)
                                total_disposal_qty += Number(reportLine.disposal_onhand)
                                total_disposal_aqt += Number(reportLine.disposal_aqt)
                                total_losses_qty += Number(reportLine.losses_onhand)
                                total_losses_aqt += Number(reportLine.losses_aqt)
                                total_reserved_qty += Number(reportLine.reserved_onhand)
                                total_reserved_aqt += Number(reportLine.reserved_aqt)

                                grand_good_qty += Number(reportLine.good_onhand)
                                grand_good_aqt += Number(reportLine.good_aqt)
                                grand_damaged_qty += Number(reportLine.damaged_onhand)
                                grand_damaged_aqt += Number(reportLine.damaged_aqt)
                                grand_disposal_qty += Number(reportLine.disposal_onhand)
                                grand_disposal_aqt += Number(reportLine.disposal_aqt)
                                grand_losses_qty += Number(reportLine.losses_onhand)
                                grand_losses_aqt += Number(reportLine.losses_aqt)
                                grand_reserved_qty += Number(reportLine.reserved_onhand)
                                grand_reserved_aqt += Number(reportLine.reserved_aqt)

                                if(this.inputFormat != '1'){
                                    total_in_qty += Number(reportLine.in_qty)
                                    total_out_qty += Number(reportLine.out_qty)
                                    total_available += available
                                    total_rr_qty += Number(reportLine.rr_qty)
                                    total_rr_cost += Number(reportLine.rr_cost)

                                    grand_in_qty += Number(reportLine.in_qty)
                                    grand_out_qty += Number(reportLine.out_qty)
                                    grand_available += available
                                    grand_rr_qty += Number(reportLine.rr_qty)
                                    grand_rr_cost += Number(reportLine.rr_cost)
                                }

                                if(i == this.birSalesReports.length-1){
                                    let sub_detail = ['', '', '']
                                    let grand_detail = ['', '', '']
                                    if(this.inputFormat == '1'){
                                        // sub_detail = ['', '', 'Sub Total :']
                                        // sub_detail.push(
                                        //     this.qtyFormatter(total_good_qty),
                                        //     this.qtyFormatter(total_damaged_qty),
                                        //     this.qtyFormatter(total_disposal_qty),
                                        //     this.qtyFormatter(total_losses_qty),
                                        //     this.qtyFormatter(total_reserved_qty),
                                        //     this.qtyFormatter(total_onhand_qty),
                                        //     this.qtyFormatter(total_intransit_qty)
                                        // )
                                        grand_detail.push('')
                                    }
                                    // else {
                                    //     sub_detail.push(
                                    //         'Sub Total :',
                                    //         this.qtyFormatter(total_onhand_qty),
                                    //         this.qtyFormatter(total_intransit_qty)
                                    //     )
                                    // }
                                    
                                    grand_detail.push(
                                        'Grand Total :',
                                        this.qtyFormatter(grand_onhand_qty),
                                        this.qtyFormatter(grand_intransit_qty)
                                    )
                                    if(this.inputFormat != '1'){
                                        sub_detail.push(
                                            this.qtyFormatter(total_in_qty),
                                            this.qtyFormatter(total_out_qty),
                                            this.qtyFormatter(total_available)
                                        )

                                        grand_detail.push(
                                            this.qtyFormatter(grand_in_qty),
                                            this.qtyFormatter(grand_out_qty),
                                            this.qtyFormatter(grand_available)
                                        )
                                    }
                                    if(this.inputFormat == '3'){
                                        sub_detail.push('')
                                        grand_detail.push('')
                                    }
                                    if(this.inputFormat != '1'){
                                        sub_detail.push('', this.qtyFormatter(total_rr_qty), this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'))
                                        grand_detail.push('', this.qtyFormatter(grand_rr_qty), this.addMaskValidation(this.convertToCurrency(grand_rr_cost), 'Z'))
                                    }
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, sub_detail))

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand_detail))
                                } else {
                                    let current_grouper = reportLine.grouper_id
                                    let next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        let sub_detail = ['', '', '']
                                        // if(this.inputFormat == '1'){
                                        //     sub_detail = ['', '', 'Sub Total :']
                                        //     sub_detail.push(
                                        //         this.qtyFormatter(total_good_qty),
                                        //         this.qtyFormatter(total_damaged_qty),
                                        //         this.qtyFormatter(total_disposal_qty),
                                        //         this.qtyFormatter(total_losses_qty),
                                        //         this.qtyFormatter(total_reserved_qty),
                                        //         this.qtyFormatter(total_onhand_qty),
                                        //         this.qtyFormatter(total_intransit_qty)
                                        //     )
                                        // } else {
                                        //     sub_detail.push(
                                        //         'Sub Total :',
                                        //         this.qtyFormatter(total_onhand_qty)
                                        //     )
                                        // }
                                        // sub_detail.push(
                                        //     'Sub Total :',
                                        //     this.qtyFormatter(total_onhand_qty)
                                        // )
                                        if(this.inputFormat != '1'){
                                            sub_detail.push(
                                                this.qtyFormatter(total_in_qty),
                                                this.qtyFormatter(total_out_qty),
                                                this.qtyFormatter(total_available)
                                            )
                                        }
                                        if(this.inputFormat == '3'){
                                            sub_detail.push('')
                                        }
                                        if(this.inputFormat != '1'){
                                            sub_detail.push('', this.qtyFormatter(total_rr_qty), this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'))
                                        }
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))

                                        total_onhand_qty = 0
                                        total_in_qty = 0
                                        total_out_qty = 0
                                        total_available = 0
                                        total_rr_qty = 0
                                        total_rr_cost = 0
                                        total_intransit_qty = 0
                                        total_good_qty = 0
                                        total_good_aqt = 0
                                        total_damaged_qty = 0
                                        total_damaged_aqt = 0
                                        total_disposal_qty = 0
                                        total_disposal_aqt = 0
                                        total_losses_qty = 0
                                        total_losses_aqt = 0
                                        total_reserved_qty = 0
                                        total_reserved_aqt = 0
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        let design_x = 340
                        let design_y = 200
                        if(this.inputFormat != 1) {
                            design_x = 400
                            design_y = 280
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"General Inventory Report (Advance)" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(15, 25, "As of " + as_of)

                        if (this.isSeparateSite == true) {
                            // doc.text(design_x,20,siteSpecific[x].report_details[0].site_name,"right");
                            doc.text(15, 30, `Site/s: ${siteSpecific[x].report_details[0].site_name}`)
                        } else {
                            let site_text = ''
                            if (this.inputSite.length == 0) {
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if (s == 0) {
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(15, 30, `Site/s: ${site_text}`)
                            // doc.text(design_x,20,site_text,"right");
                        }
                        let filterText = dissectReportFilters(parameters, this.displayOptions, this.formatOptions)
                        const { basic, advance } = filterText
                        doc.text(15, 35, `Filter/s: ${basic}`)
                        if (Object.keys(parameters.advanced_filter).length !== 0) {
                            doc.text(15, 40, `Product Filter/s: ${advance}`)
                        }
                        let col_width_0 = 0
                        let col_width_1 = 0
                        let col_width_2 = 60
                        let col_width_3 = 60
                        let col_width_4 = 30
                        let col_width_5 = 0
                        let col_width_6 = 0
                        let col_width_7 = 0
                        let col_width_8 = 0
                        let col_width_9 = 0
                        if(this.inputFormat == '1'){
                            col_width_0 = 5
                            col_width_1 = 5
                            col_width_2 = 80
                            col_width_3 = 20
                            col_width_4 = 20
                            col_width_5 = 10
                            col_width_6 = 10
                            col_width_7 = 10
                            col_width_8 = 10
                            col_width_9 = 10
                        } else if(this.inputFormat == '2'){
                            col_width_3 = 90
                            col_width_4 = 30
                        }
                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 30 + col_width_0},
                            1: {cellWidth: 30 + col_width_1},
                            2: {cellWidth: 40 + col_width_2},
                            3: {cellWidth: col_width_3},
                            4: {cellWidth: col_width_4},
                            5: {cellWidth: 30 - col_width_5},
                            6: {cellWidth: 30 - col_width_6},
                            7: {cellWidth: 30 - col_width_7},
                            8: {cellWidth: 30 - col_width_8},
                            9: {cellWidth: 30 - col_width_9},
                            10: {cellWidth: 30},
                            11: {cellWidth: 30}
                        }

                        // console.log("------------")
                        // console.log("reportData",reportData)

                        doc.autoTable({
                            // startY: 35,
                            startY: Object.keys(this.params).length !== 0? 45 : 40,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            margin: {bottom: 25},
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[4] == 'Grand Total :' || data.row.raw[3] == 'Sub Total :' || data.row.raw[4] == 'Sub Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                        if(this.inputFormat != '1'){
                            var finalY = doc.lastAutoTable.finalY;
                            var legends = ['Available = On-Hand - Outgoing']
                            reportUtils.pdfTools.addLegend(doc, legends, finalY)
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "General Inventory Report (Advance)" + group_text, design_x, design_y, i, pageCount)
                        }
                    }
                    

                    window.open(URL.createObjectURL(doc.output("blob")))
                    //doc.save(`General_Inventory_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                // console.log(this.inputSite);
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let sorting = this.inputSortBy
                if(this.inputFormat != '1'){
                    sorting = this.inputSortExtendedBy
                }

                this.fileDate = this.inputDate.format('DD_MM_YYYY_h;mmA');
                // if no site is selected, send all site IDs under the selected company to fix filter issue on All Site
                let siteId = this.inputSite.length > 0 ? this.inputSite.toString() : this.userSiteCompanyOptions.map(site => site.id).toString();

                let parameters = {
                    "site_id": siteId,
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "isTI": this.isConsider,
                    "isFormat": this.inputFormat,
                    "isPrev": this.isShowPrev,
                    "advanced_filter": this.params
                }
                let get_request = []
                if(this.inputFormat == 4){
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory_list?', parameters);
                }
                else {
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory?', parameters);
                }

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                // test
                let siteSpecific = get_request;
                if (get_request.data !=undefined){
                    siteSpecific = get_request.data;
                }
                if(siteSpecific.length > 0 && this.inputFormat != 4){
                    let headers = [];
                    let header_top = [];
                    let site_specific = [];

                    if(['1', '5'].includes(this.inputFormat)){
                        const grouper = this.inputGroupBy.replace('_id', '').replace(/^\w/, (c) => c.toUpperCase());
                        header_top.push(
                            this.isSeparateSite ? 'Site' : grouper,                            
                            'Barcode',
                            // 'Stock #',
                            // 'Ref Code',
                            'Description',
                            'Brand',
                            'Good',
                            'Damaged',
                            'Reserved',
                            'Losses',
                            'Disposal',
                            // 'Good On-hand Qty',
                            // 'Good AQT',
                            // 'Damaged On-hand Qty',
                            // 'Damaged AQT',
                            // 'Reserved On-hand Qty',
                            // 'Reserved AQT',
                            // 'Losses On-hand Qty',
                            // 'Losses AQT',
                            // 'Disposal On-hand Qty',
                            // 'Disposal AQT',
                            'Total On-hand Qty',
                            // 'On-Hand',
                            'In-transit Qty',
                            'Total Qty',
                            'Unit Price',
                            'Total Price',
                            'Available Quantity to Transact'
                        )
                        headers = header_top
                    } else {
                        header_top.push(
                            // 'PCode',
                            'Barcode',
                            // 'Stock #',
                            'Description',
                            'On-Hand',
                            'In-transit',
                            'Incoming',
                            'Outgoing',
                            'Available'
                        )

                        if(this.inputFormat == '3'){
                            header_top.push('# of day/s\nsince last sale')
                        }

                        if(this.isConsider == true){
                            header_top.push('Last Arrival (RR/STI Document) - Date','Last Arrival (RR/STI Document) - Quantity','Last Arrival (RR/STI Document) - Cost')
                        }else{
                          header_top.push('Last Arrival (RR Document) - Date','Last Arrival (RR Document) - Quantity','Last Arrival (RR Document) - Cost')
                        }

                        headers = header_top
                    }

                    // console.log("-------------------")
                    let grand_grand_total = 0
                    for (let x=0; x < siteSpecific.length; x++){
                        // console.log("siteSpecific",siteSpecific);
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_onhand_qty = 0
                            let total_in_qty = 0
                            let total_out_qty = 0
                            let total_rr_qty = 0
                            let total_rr_cost = 0
                            let total_available = 0
                            let total_intransit_qty = 0

                            let grand_onhand_qty = 0
                            let grand_in_qty = 0
                            let grand_out_qty = 0
                            let grand_rr_qty = 0
                            let grand_rr_cost = 0
                            let grand_available = 0
                            let grand_intransit_qty = 0

                            let grand_good_qty = 0
                            let grand_good_aqt = 0
                            let grand_damaged_qty = 0
                            let grand_damaged_aqt = 0
                            let grand_disposal_qty = 0
                            let grand_disposal_aqt = 0
                            let grand_losses_qty = 0
                            let grand_losses_aqt = 0
                            let grand_reserved_qty = 0
                            let grand_reserved_aqt = 0
                            let total_good_qty = 0
                            let total_good_aqt = 0
                            let total_damaged_qty = 0
                            let total_damaged_aqt = 0
                            let total_disposal_qty = 0
                            let total_disposal_aqt = 0
                            let total_losses_qty = 0
                            let total_losses_aqt = 0
                            let total_reserved_qty = 0
                            let total_reserved_aqt = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                if (reportLine.barcode == "NS1000489934"){
                                    console.log(reportLine)
                                }
                                let grouper_name = reportLine.grouper_name

                                // Accumulate the total on-hand quantity (including good, damaged, reserved, losses)
                                totalOnHandQty += temp_onhand_qty

                                if(grouper == 'start' && !['5', '6'].includes(this.inputFormat)){
                                    let detail_header = [grouper_name];
                                    reportData.push(detail_header)
                                } else {
                                    if(grouper != reportLine.grouper_name && !['5', '6'].includes(this.inputFormat)){
                                        let detail_header = [grouper_name]
                                        reportData.push(detail_header)
                                    }
                                }
                                if(['5', '6'].includes(this.inputFormat)){
                                    grouper = 'start'
                                } else {
                                    grouper = reportLine.grouper_name
                                }

                                let as_of_date = this.inputDate.format('YYYY-MM-DD')

                                let no_days_display = ''
                                if(reportLine.sales_date != null){
                                    let no_days = this.diffDays(reportLine.sales_date, as_of_date)
                                    no_days_display = this.formatNumber(Number(no_days))
                                }

                                let rr_date = ''
                                let rr_qty = ''
                                let rr_cost = ''
                                if(reportLine.rr_date != null){
                                    rr_date = reportLine.rr_date
                                    rr_qty = this.qtyFormatter(reportLine.rr_qty)
                                    rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                                }
                                let available = Number(reportLine.onhand_qty) - Number(reportLine.out_qty)

                                let detail = [
                                    // reportLine.product_id,
                                    reportLine.site_name,
                                    reportLine.barcode,
                                    // reportLine.stock_no
                                ]
                                // if(['1', '5'].includes(this.inputFormat)){
                                //     detail.push(reportLine.reference_code)
                                // }
                                var plus_onhand =  (Number(reportLine.good_onhand) || 0) + 
                                        (Number(reportLine.damaged_onhand) || 0) + 
                                        (Number(reportLine.reserved_onhand) || 0) + 
                                        (Number(reportLine.losses_onhand) || 0) + 
                                        (Number(reportLine.disposal_onhand) || 0)
                                var temp_onhand_qty = (Number(reportLine.good_onhand) || 0) + 
                                (Number(reportLine.damaged_onhand) || 0) + 
                                (Number(reportLine.reserved_onhand) || 0) + 
                                (Number(reportLine.losses_onhand) || 0) + 
                                (Number(reportLine.disposal_onhand) || 0) || Number(reportLine.onhand_qty)
                                if(plus_onhand < reportLine.onhand_qty && this.inputSite.length > 1){
                                    temp_onhand_qty = Number(reportLine.onhand_qty)
                                }
                                if (plus_onhand <= 0 && Number(reportLine.onhand_qty) > 0){
                                    temp_onhand_qty = Number(reportLine.onhand_qty)
                                }
                                detail.push(
                                    reportLine.name,
                                    reportLine.brand_name,
                                    this.qtyFormatter(reportLine.good_onhand),
                                    //this.qtyFormatter(reportLine.good_aqt),
                                    this.qtyFormatter(reportLine.damaged_onhand),
                                    //this.qtyFormatter(reportLine.damaged_aqt),
                                    this.qtyFormatter(reportLine.reserved_onhand),
                                    //this.qtyFormatter(reportLine.reserved_aqt),
                                    this.qtyFormatter(reportLine.losses_onhand),
                                    //this.qtyFormatter(reportLine.losses_aqt),
                                    this.qtyFormatter(reportLine.disposal_onhand),
                                    //this.qtyFormatter(reportLine.disposal_aqt),
                                    // this.qtyFormatter(reportLine.onhand_qty),
                                    this.qtyFormatter(
                                        temp_onhand_qty
                                    ),
                                    this.qtyFormatter(reportLine.intransit_qty),
                                    this.qtyFormatter(
                                        temp_onhand_qty +
                                        (Number(reportLine.intransit_qty) || 0)
                                    ),
                                    this.qtyFormatter(reportLine.price),
                                    this.qtyFormatter(
                                        temp_onhand_qty * 
                                        (Number(reportLine.price) || 0)
                                    ),
                                    this.qtyFormatter(reportLine.good_aqt)
                                )

                                if(this.inputFormat != '1'){
                                    detail.push(
                                        this.qtyFormatter(reportLine.intransit_qty),
                                        this.qtyFormatter(reportLine.in_qty),
                                        this.qtyFormatter(reportLine.out_qty),
                                        this.qtyFormatter(available)
                                    )
                                }
                                if(this.inputFormat == '3'){
                                    detail.push(no_days_display)
                                }
                                if(this.inputFormat != '1'){
                                    detail.push(rr_date, rr_qty, this.addMaskValidation(rr_cost), 'Z')
                                }
                                reportData.push(detail)

                                total_onhand_qty += Number(reportLine.onhand_qty)
                                grand_onhand_qty += Number(temp_onhand_qty)
                                grand_grand_total += Number(temp_onhand_qty +
                                (Number(reportLine.intransit_qty) || 0))
                                total_good_qty += Number(reportLine.good_onhand)
                                total_good_aqt += Number(reportLine.good_aqt)
                                total_damaged_qty += Number(reportLine.damaged_onhand)
                                total_damaged_aqt += Number(reportLine.damaged_aqt)
                                total_disposal_qty += Number(reportLine.disposal_onhand)
                                total_disposal_aqt += Number(reportLine.disposal_aqt)
                                total_losses_qty += Number(reportLine.losses_onhand)
                                total_losses_aqt += Number(reportLine.losses_aqt)
                                total_reserved_qty += Number(reportLine.reserved_onhand)
                                total_reserved_aqt += Number(reportLine.reserved_aqt)

                                grand_good_qty += Number(reportLine.good_onhand)
                                grand_good_aqt += Number(reportLine.good_aqt)
                                grand_damaged_qty += Number(reportLine.damaged_onhand)
                                grand_damaged_aqt += Number(reportLine.damaged_aqt)
                                grand_disposal_qty += Number(reportLine.disposal_onhand)
                                grand_disposal_aqt += Number(reportLine.disposal_aqt)
                                grand_losses_qty += Number(reportLine.losses_onhand)
                                grand_losses_aqt += Number(reportLine.losses_aqt)
                                grand_reserved_qty += Number(reportLine.reserved_onhand)
                                grand_reserved_aqt += Number(reportLine.reserved_aqt)
                                total_intransit_qty += Number(reportLine.intransit_qty)

                                if(this.inputFormat != '1'){
                                    total_intransit_qty += Number(reportLine.intransit_qty)
                                    total_in_qty += Number(reportLine.in_qty)
                                    total_out_qty += Number(reportLine.out_qty)
                                    total_available += available
                                    total_rr_qty += Number(reportLine.rr_qty)
                                    total_rr_cost += Number(reportLine.rr_cost)

                                    grand_intransit_qty += Number(reportLine.intransit_qty)
                                    grand_in_qty += Number(reportLine.in_qty)
                                    grand_out_qty += Number(reportLine.out_qty)
                                    grand_available += available
                                    grand_rr_qty += Number(reportLine.rr_qty)
                                    grand_rr_cost += Number(reportLine.rr_cost)
                                }

                                // Add the row for the "Sub Total"
                                let totalOnHandQty = 0;
                                totalOnHandQty += temp_onhand_qty

                                if(i == this.birSalesReports.length-1){
                                    let sub_detail = ['', '', '']
                                    let grand_detail = ['', '', '']
                                    let subTotalDetail = ['', '']
                                    if(['1', '5'].includes(this.inputFormat)){
                                        // sub_detail.push('',
                                        // 'Sub Total :',
                                        // this.qtyFormatter(total_good_qty),
                                        // this.qtyFormatter(total_damaged_qty),
                                        // this.qtyFormatter(total_disposal_qty),
                                        // this.qtyFormatter(total_losses_qty),
                                        // this.qtyFormatter(total_reserved_qty),
                                        // this.qtyFormatter(total_onhand_qty),
                                        // this.qtyFormatter(total_intransit_qty))
                                        // grand_detail.push(
                                        //     "Sub Total :",  // Label for Sub Total
                                        //     this.qtyFormatter(totalOnHandQty),  // Display the calculated total on-hand qty
                                        // );
                                        subTotalDetail.push(
                                            'Sub Total :',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            this.qtyFormatter(totalOnHandQty), // Display the total on-hand quantity for all rows
                                        )
                                    }else{
                                        // sub_detail.push(
                                        //     'Sub Total :',
                                        //     this.qtyFormatter(total_onhand_qty)
                                        // )
                                        grand_detail.push(
                                            'Grand Total :',
                                            this.qtyFormatter(grand_onhand_qty)
                                        )
                                    }
                                    if(this.inputFormat != '1'){
                                        sub_detail.push(
                                            this.qtyFormatter(total_intransit_qty),
                                            this.qtyFormatter(total_in_qty),
                                            this.qtyFormatter(total_out_qty),
                                            this.qtyFormatter(total_available)
                                        )

                                        // grand_detail.push(
                                        //     this.qtyFormatter(grand_intransit_qty),
                                        //     this.qtyFormatter(grand_in_qty),
                                        //     this.qtyFormatter(grand_out_qty),
                                        //     this.qtyFormatter(grand_available)
                                        // )
                                    }
                                    if(this.inputFormat == '3'){
                                        sub_detail.push('')
                                        grand_detail.push('')
                                    }
                                    if(this.inputFormat != '1'){
                                        sub_detail.push('', this.qtyFormatter(total_rr_qty), this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'))
                                        grand_detail.push('', this.qtyFormatter(grand_rr_qty), this.addMaskValidation(this.convertToCurrency(grand_rr_cost), 'Z'))
                                    }
                                    if(!['5', '6'].includes(this.inputFormat)){
                                        reportData.push(["---"])
                                        reportData.push(sub_detail)
                                    }

                                    // reportData.push(["---"])
                                    // reportData.push(subTotalDetail)
                                } else {
                                    let current_grouper = reportLine.grouper_id
                                    let next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        let sub_detail = ['', '', '']
                                        // if(['1', '5'].includes(this.inputFormat)){
                                        //     sub_detail.push('',
                                        //     'Sub Total :',
                                        //     this.qtyFormatter(total_good_qty),
                                        //     this.qtyFormatter(total_damaged_qty),
                                        //     this.qtyFormatter(total_disposal_qty),
                                        //     this.qtyFormatter(total_losses_qty),
                                        //     this.qtyFormatter(total_reserved_qty),
                                        //     this.qtyFormatter(total_onhand_qty),
                                        //     this.qtyFormatter(total_intransit_qty))
                                        // }else{
                                        //     sub_detail.push(
                                        //         'Sub Total :',
                                        //         this.qtyFormatter(total_onhand_qty)
                                        //     )
                                        // }
                                        
                                        if(this.inputFormat != '1'){
                                            sub_detail.push(
                                                this.qtyFormatter(total_intransit_qty),
                                                this.qtyFormatter(total_in_qty),
                                                this.qtyFormatter(total_out_qty),
                                                this.qtyFormatter(total_available)
                                            )
                                        }
                                        if(this.inputFormat == '3'){
                                            sub_detail.push('')
                                        }
                                        if(this.inputFormat != '1'){
                                            sub_detail.push('', this.qtyFormatter(total_rr_qty), this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'))
                                        }
                                        if(!['5', '6'].includes(this.inputFormat)){
                                            reportData.push(["-----"])

                                            if (this.isSeparateSite == true) {
                                                reportData.push(["Site: " + siteSpecific[x].report_details[0].site_name]);
                                            }

                                            // Remove extas space on row
                                            if (sub_detail && typeof sub_detail === 'string' && sub_detail.trim() !== '') {
                                                reportData.push(sub_detail);
                                            }
                                        }

                                        total_intransit_qty = 0
                                        total_onhand_qty = 0
                                        total_in_qty = 0
                                        total_out_qty = 0
                                        total_available = 0
                                        total_rr_qty = 0
                                        total_rr_cost = 0
                                        total_good_qty = 0
                                        total_good_aqt = 0
                                        total_damaged_qty = 0
                                        total_damaged_aqt = 0
                                        total_disposal_qty = 0
                                        total_disposal_aqt = 0
                                        total_losses_qty = 0
                                        total_losses_aqt = 0
                                        total_reserved_qty = 0
                                        total_reserved_aqt = 0
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        // if (this.isSeparateSite == true) {
                        //     reportData.push(["Site: " + siteSpecific[x].report_details[0].site_name]);
                        // } else {
                        //     let site_text = ''
                        //     if (this.inputSite.length == 0) {
                        //         site_text = 'All Sites'
                        //     } else {
                        //         let sites = this.inputSite
                        //         for (var s = 0; s < sites.length; s++) {
                        //             if (s == 0) {
                        //                 site_text += this.siteOptions.find(x => x.id === sites[s]).name
                        //             } else {
                        //                 site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                        //             }
                        //         }
                        //     }
                        //     reportData.unshift([site_text]);
                        // }

                        // if(this.inputFormat != '1'){
                        //     var legends = ['Available = On-Hand - Outgoing']
                        //     reportData = reportUtils.csvxlsxTools.addLegend(reportData, legends)
                        // }

                        if (['1', '2', '3', '5', '6'].includes(this.inputFormat) && x === siteSpecific.length - 1) {
                            if (this.inputFormat =='1'){
                                reportData.push(
                                    ['','','','','','','','','','',
                                    'Grand Total :',
                                    this.qtyFormatter(grand_grand_total)]
                                )
                            }
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }

                            reportData.push(['', '', '', '', ''])
                            reportData.push(["General Inventory Report (Advance)" + group_text, "Printed By: " + printed_by,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])

                            console.log("checkpoint: inside condition")
                            // console.log(reportData)
                        }

                        // let printed_by = secureStorage.getItem("email")
                        // if(printed_by == null){
                        //     printed_by = ''
                        // }

                        // reportData.push(["General Inventory Report (Advance)" + group_text, "Printed By: " + printed_by,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)

                        // this.JsonData = site_specific;
										}
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else if(this.inputFormat == 4){
                    let headers = [];
                    let header_top = [];
                    let site_specific = [];

                    header_top.push('PRODUCT / INVENTORY CODE','ITEM DESCRIPTION','ADDRESS','CODE','REMARKS','INVENTORY VALUATION METHOD', 'UNIT PRICE', 'QUANTITY IN STOCKS', 'UNIT OF MEASUREMENT', 'TOTAL WEIGHT / VOLUME', 'TOTAL COST')
                    headers = header_top
    

                    // console.log("-------------------")
                    for (let x=0; x < siteSpecific.length; x++){
                        // console.log("siteSpecific",siteSpecific);
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        let total_onhand_qty = 0;
                        let ttl_cost = 0;
                        let grand_onhand_qty = 0;
                        let grand_cost = 0;
                        let group_pid = 0
                        let ttl_cost_per_pid = 0
                        for(let i=0; i < this.birSalesReports.length; i++){
                            let line = this.birSalesReports[i];
                            if (group_pid == line.product_id){
                                ttl_cost_per_pid += Number(line.total_cost)
                            }
                            if (group_pid > 0 && group_pid != line.product_id){
                                if (this.birSalesReports[i-1].code == "CH" && i > 1){
                                    if (group_pid == this.birSalesReports[i-2].product_id && this.birSalesReports[i-2].code != "CH"){
                                        this.birSalesReports[i-2].sum_ttl_cost = ttl_cost_per_pid
                                    }
                                }else{
                                    this.birSalesReports[i-1].sum_ttl_cost = ttl_cost_per_pid
                                }
                                group_pid = line.product_id
                                ttl_cost_per_pid = 0
                                if (group_pid == line.product_id){
                                    ttl_cost_per_pid += Number(line.total_cost)
                                }
                            }
                            if (group_pid == line.product_id && (i+1) == this.birSalesReports.length){
                                if (this.birSalesReports[i].code != "CH"){
                                    this.birSalesReports[i].sum_ttl_cost = ttl_cost_per_pid
                                }
                            }
                            group_pid = line.product_id
                        }
                        for(let i=0; i < this.birSalesReports.length; i++){
                            let reportLine = this.birSalesReports[i];
                            if (reportLine.sum_ttl_cost != undefined && reportLine.sum_ttl_cost > 0){
                                var cost_discrepancy = Number(reportLine.inventory_cost_total) - Number(reportLine.sum_ttl_cost)
                                if (cost_discrepancy != 0 && reportLine.code !='CH'){
                                    reportLine.total_cost = Number(reportLine.total_cost) + Number(cost_discrepancy)
                                }
                            }
                            // let grouper_name = reportLine.grouper_name
                            // if(grouper == 'start'){
                            //     let detail_header = [grouper_name];
                            //     // reportData.push(['', '', '', '' , '', 'MERCHANDISE/ RAW MATERIALS / GOODS IN PROCESS / FINISHED GOODS INVENTORY'])
                            //     // reportData.push(['', '', '', '' , '', 'AS OF ' + this.inputDate.format('YYYY-MM-DD')])
                            //     reportData.push(detail_header)
                            // } else {
                            //     if(grouper != reportLine.grouper_name){
                            //         let detail_header = [grouper_name]
                            //         reportData.push(detail_header)
                            //     }
                            // }
                            // grouper = reportLine.grouper_name

                            let as_of_date = this.inputDate.format('YYYY-MM-DD')

                            let no_days_display = ''
                            if(reportLine.sales_date != null){
                                let no_days = this.diffDays(reportLine.sales_date, as_of_date)
                                no_days_display = this.formatNumber(Number(no_days))
                            }

                            let rr_date = ''
                            let rr_qty = ''
                            let rr_cost = ''
                            if(reportLine.rr_date != null){
                                rr_date = reportLine.rr_date
                                rr_qty = this.qtyFormatter(reportLine.rr_qty)
                                rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                            }
                            let available = Number(reportLine.onhand_qty) - Number(reportLine.out_qty)
                            var temp_ttl_cost = (Number(reportLine.total_cost) == 0 && Number(reportLine.onhand_qty)!=0 && reportLine.code!="CH") ? reportLine.sum_ttl_cost : reportLine.total_cost 
                            let detail = [
                                reportLine.barcode,
                                reportLine.name,
                                reportLine.site_name,
                                reportLine.code,
                                '',
                                'Weighted Average',
                                this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Z'),
                                this.qtyFormatter(reportLine.onhand_qty),
                                (reportLine.reference_code != null) ? reportLine.reference_code.split("-")[1] : '',
                                // this.qtyFormatter(reportLine.weight),
                                // Number(reportLine.onhand_qty) + '+++' + Number(reportLine.cost) + '+++' + (Number(reportLine.cost) * Number(reportLine.onhand_qty)),
                                '',
                                // this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost) * Number(reportLine.onhand_qty)), 'Z')
                                this.addMaskValidation(this.convertToCurrency(Number(temp_ttl_cost)), 'Z')
                            ]

                            // console.log("reportLine: ", reportLine)
                            // console.log("detail: ", detail)

                            reportData.push(detail)

                            total_onhand_qty += Number(reportLine.onhand_qty)
                            grand_onhand_qty += Number(reportLine.onhand_qty)
                            ttl_cost += Number(reportLine.onhand_qty * reportLine.cost)
                            // grand_cost += Number(reportLine.onhand_qty * reportLine.cost)
                            grand_cost += Number(reportLine.total_cost);

                            // if(i == this.birSalesReports.length-1){
                            //     let sub_detail = ['', '', '', '', '', '']
                            //     let grand_detail = ['', '', '', '', '', '']
                                
                            //     sub_detail.push(
                            //         'SUBTOTAL QUANTITY IN STOCKS:',
                            //         this.qtyFormatter(total_onhand_qty),
                            //         '', '',
                            //         this.addMaskValidation(this.convertToCurrency(Number(total_cost)), 'Z')
                            //     )
                            
                            //     grand_detail.push(
                            //         'GRAND TOTAL QUANTITY IN STOCKS:',
                            //         this.qtyFormatter(grand_onhand_qty),
                            //         '',
                            //         'GRAND TOTAL COST:',
                            //         this.addMaskValidation(this.convertToCurrency(Number(grand_cost)), 'Z')
                            //     )

                            //     grand_detail.push(
                            //         'GRAND TOTAL QUANTITY IN STOCKS:',
                            //         this.qtyFormatter(grand_onhand_qty),
                            //         '',
                            //         'GRAND TOTAL COST:',
                            //         this.addMaskValidation(this.convertToCurrency(Number(grand_cost)), 'Z')
                            //     )

                            //     reportData.push(["---"])
                            //     reportData.push(sub_detail)

                            //     reportData.push(['', '', '', '', '__________________________________________'])
                            //     reportData.push(['', '', '', '', '     Name and Signature of Authorized'])
                            //     reportData.push(['', '', '', '', '               Representative'])
                            //     reportData.push(['', '', '', '', 'TIN : ____________________________________'])

                            //     reportData.push(["---"])
                            //     reportData.push(grand_detail)
                            // } else {
                            //     let current_grouper = reportLine.grouper_id
                            //     let next_grouper = this.birSalesReports[i+1].grouper_id

                            //     if(current_grouper != next_grouper){
                            //         let sub_detail = ['', '', '', '', '', '']
                            //         sub_detail.push(
                            //             'SUBTOTAL QUANTITY IN STOCKS:',
                            //             this.qtyFormatter(total_onhand_qty),
                            //             '', 'SUBTOTAL COST:',
                            //             this.addMaskValidation(this.convertToCurrency(Number(total_cost)), 'Z')
                            //         )
                            //         reportData.push(["-----"])
                            //         reportData.push(sub_detail)

                            //         reportData.push(['', '', '', '', '__________________________________________'])
                            //         reportData.push(['', '', '', '', '     Name and Signature of Authorized'])
                            //         reportData.push(['', '', '', '', '               Representative'])
                            //         reportData.push(['', '', '', '', 'TIN : ____________________________________'])

                            //         total_onhand_qty = 0
                            //         total_cost = 0
                            //     }
                            // }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        if(this.isSeparateSite == true){
                            // reportData.push(["Site: " + siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }

                        // only add legends and report header details on the footer once at the end of the reportt
                        if (this.inputFormat != '1' && x === siteSpecific.length - 1) {
                            var legends = [
                                'CH = Goods on consignment held by the taxpayer',
                                'P = Parked goods or goods owned by related parties',
                                'O = Goods owned by the taxpayer',
                                'CO = Goods out on consignment held in the hands of entity other than taxpayer'
                            ];

                            reportData.push(['', '', '', '', '']);
                            reportData.push(['Note 1', 'a. Include all goods whether taxpayer has title thereto or not, provided these goods are actually situated in location/address at the Head Office or Branch or Facilities (with or without sales activity of the taxpayer). Facilities']);
                            reportData.push(['', 'shall include but not limited to place of production, showroom, warehouse, storage place, leased property, etc. Include also goods out on consignment, though not physically present are nonetheless owned by the taxpayer.']);
                            reportData.push(['', '', '', '', '']);
                            reportData = reportUtils.csvxlsxTools.addLegendForInventoryListReport(reportData, legends);
                            reportData.push(['', '', '', '', '']);
                            reportData.push(['Note 2', 'Indicate Costing Method applied, e.g., Standard Costing, FIFO, Weighted Average, Specific Identification, etc.']);
                            reportData.push(['', '', '', '', '']);
                            reportData.push(['', '', 'We declare, under the penalties of perjury, that this schedule has been made in good faith, verified by us, and to the best of our knowledge and belief, is true and correct pursuant to the provisions of the National Internal ']);
                            reportData.push(['', '', 'Revenue Code, as amended, and the regulations issued under authority thereof.']);
                            reportData.push(['', '', '', '', '']);
                            reportData.push(['', '', '', '', '', '', '______________________________________________________________________']);
                            reportData.push(['', '', '', '', '', '', '', '', '   Name and Signature of Authorized']);
                            reportData.push(['', '', '', '', '', '', '', '', '', 'Representative']);
                            reportData.push(['', '', '', '', '', '', 'TIN: __________________']);

                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }

                            reportData.push(['', '', '', '', ''])
                            reportData.push(["General Inventory Report (Advance)" + group_text, "Printed By: " + printed_by,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])
                        }

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i = 0; i < values_length; i++){
                            var result = Object.assign.apply({}, keys.map( (val, index) => ({
                                [val]: values[i][index]
                            })));
                            newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null) {
                                    obj[i] = '';
                                }
                            }
                        });
                        site_specific.push(newJsonData)

                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    if (get_request.status !=undefined && get_request.status == "ongoing"){
                        component_x.$notification['success']({
                            message: 'Successful Operation',
                            description: "Generate Report is ongoing, you can check the ongoing jobs for updates.",
                            style: {
                                color: 'rgba(0, 0, 0, 0.65)',
                                border: '1px solid #b7eb8f',
                                backgroundColor: '#f6ffed'
                            },
                            btn: h => {
                                return h(
                                'base-button',
                                {
                                    props: {
                                    type: 'primary',
                                    class: 'btn-sm',
                                    },
                                    on: {
                                    click: () => component_x.$router.push("/jobs"),
                                    },
                                },
                                'View Jobs',
                                );
                            },
                        });
                    }else{
                        reportUtils.openNotificationWithIcon(component_x, 'error', 'No Data.');
                    }
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            },
            // bryan
            selectLocationFunction(){
              if(this.inputSite.length !== 0){
                this.inputSite = []
              }
              this.siteOptions.map(({location_name, id}) => {
                if(location_name === this.selectedLocation){
                  this.inputSite = [...this.inputSite, id]
                }
              })
            }
        }
    };
</script>

<style></style>
